export class DialogModelLogisticsCoinsEdit {
    constructor(
      public data: any
    ) {}
  }